import * as React from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import { attempt } from 'lodash';


const iFormat= 'YYYY-MM-DD HH:mm:ss';

const ManagerAttdncPartDismiss = ({record, dialogHandler, callback}) =>  {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const [smstList, set_smstList] = useState([])
  const [smst, set_smst] = useState({})
  const [lectures, set_lectures] = useState([])
  const [lecture, set_lecture] = useState({})
  const [attdncs, set_attdncs] = useState([])
  const [attdnc, set_attdnc] = useState({})
  const [subLectureTime, set_subLectureTime] = useState(null)
  const [subStartTime, set_subStartTime] = useState(null)
  const [subEndTime, set_subEndTime] = useState(null)
  // redux
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';


  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return 
    }
    else {
      dialogHandler[1](false)
      if(callback) {
        callback()
      }
    }
  }

  const fetchSmstList = async() => {
		// const url = `/smst/last/2/${schola.id}`
		const url = `/smst/attdnc/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			alert(resp.repMessage)
			return
		}

		const repMessage = JSON.parse(resp.repMessage)
		const smstList = JSON.parse(repMessage.records)
		return smstList
  }

  const onLoad =  async() => {
    const smstList = await fetchSmstList()
    if(smstList) {
      set_smstList(smstList)
    }
  }

  const fetchLectures = async (smstId) => {
    const url = `/lecture/smst/${smstId}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchAttdncs = async(lectureId) => {
    const url = `/attdnc/lecture/${lectureId}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const attdncs = records.reduce((acc, cur) => {
      const found = acc.find(r => r.id === cur.attdnc.id)
      if(!found) {
        acc.push(cur.attdnc)
      }
      return acc
    },[])

    return attdncs
  }

  const onChangeSmst = async(smstId) => {
    set_lectures([])
    set_attdnc({})
    const lectures = await fetchLectures(smstId)
    if(lectures) {
      lectures.sort((a, b) => a.title.localeCompare(b.title))
      set_lectures(lectures)
    }
  }

  const onChangeLecture = async(lecture) => {
    set_attdnc({})
    if(lecture?.id) {
      const attdncs = await fetchAttdncs(lecture.id)
      set_attdncs(attdncs)
    }
  }

  const changeLectureTime = async() => {
    if(!attdnc?.id) {
      alert('휴강할 수업일이 입력되지 않았습니다.')
      return
    }
    if(!subLectureTime) {
      alert('휴강일이 입력되지 않았습니다. ')
      return
    } 
    else {
      const dt = moment(subLectureTime, iFormat, true)
      if(!dt.isValid()) {
        alert('휴강일 날짜가 형식에 맞지 않습니다.')
        return
      }
    }

    attdnc.subLectureTime = subLectureTime
    attdnc.subStartTime = moment(subStartTime, iFormat).format('HH:mm')
    attdnc.subEndTime= moment(subEndTime, iFormat).format('HH:mm')

    const url =`/bing/dismiss/${schola.id}`
    const data = attdnc
    openIndicator()
    const resp = await WebService.post(url, data)  
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('저장되었습니다.')
  }

  const onSubmit = async() => {
    if(!attdnc.id) {
      alert('휴강할 수업일이 입력되지 않았습니다.')
      return
    }
    const url = `/bing/dismiss/${schola.id}/${attdnc.id}`
    const resp = await WebService.post(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('저장되었습니다.')
  }

  useEffect(() => {
    if(dialogHandler[0]) {
      onLoad()
    }
  },[dialogHandler[0]])
  
  useEffect(() => {
    if(smstList.length === 1) {
      set_smst(smstList[0])
    }
  }, [smstList])

  useEffect(() => {
    if(smst?.id) {
      onChangeSmst(smst.id)
    }
  }, [smst])

  useEffect(() => {
    onChangeLecture(lecture) 
  }, [lecture])

  
  useEffect(() => {
    console.log('attdnc changed ===>', attdnc)
    // if(attdnc?.id) {
      if(attdnc?.subLectureTime) {
        set_subLectureTime(attdnc.subLectureTime) 
      }
      else {
        console.log('set subLectureTime null')
        set_subLectureTime(null) 
      }

      if(attdnc?.subStartTime) {
        console.log('subStartTime=>', attdnc.subStartTime)
        set_subStartTime(moment(attdnc.subStartTime, 'HH:mm') )
      }
      else {
        set_subStartTime(null)
      }

      if(attdnc?.subEndTime) {
        set_subEndTime(moment(attdnc.subEndTime, 'HH:mm') )
      }
      else {
        set_subEndTime(null)
      }
    // }
  }, [attdnc])
  

  return (
    <Fragment>
      <Dialog record={record} open={dialogHandler[0]} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            휴강일 지정
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='gisu' size='small'>
                년도/기수
              </InputLabel>
                  <Select
                    labelId='gisu'
                    required
                    label='년도/기수'
                    name={"smst"}
                    value={smst}
                    size='small'
                    onChange={async (e) => {
                      set_smst(e.target.value)
                    }}>
                    {smstList.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s}>
                          {s.year}/{s.gisu}
                        </MenuItem>
                      )
                    })}
                  </Select>
          </FormControl>

          <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='gisu' size='small'>
                강좌
              </InputLabel>
                  <Select
                    labelId='lecture'
                    required
                    label='강좌'
                    name={"lecture"}
                    value={lecture}
                    size='small'
                    onChange={async (e) => {
                      set_lecture(e.target.value)
                    }}>
                    {lectures.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s}>
                          {s.title}
                        </MenuItem>
                      )
                    })}
                  </Select>
          </FormControl>
          <FormControl fullWidth sx={{mt:1, mb:1}}>
              <InputLabel id='attdnc' size='small'>
                휴강할 수업일               
              </InputLabel>
                  <Select
                    labelId='attdnc'
                    required
                    label='휴강할 수업일'
                    name={"attdnc"}
                    value={attdnc}
                    size='small'
                    onChange={async (e) => {
                      console.log('attdnc=>', e.target.value)
                      set_attdnc(e.target.value)
                    }}>
                    {attdncs.map((s, index) => {
                      return (
                        <MenuItem key={index} value={s}>
                          {moment(s.lectureTime, iFormat).format('YYYY-MM-DD')}
                        </MenuItem>
                      )
                    })}
                  </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <Button onClick={handleClose} style={{margin:5}}>
              닫기
            </Button>
           <ConfirmDialog
              btn={<Button variant='contained'>휴강일 저장</Button>}
              title={'주의'}
              content={'휴강일 지정 후에는 복구할 수 없습니다. \n 휴강일을 저장하시겠습니까?'}
              bc={'error'}
              preHandle={ async () => {
                if(!attdnc?.id) {
                  alert('휴강할 수업일이 지정되지 않았습니다.')
                  return false
                }
                else {
                  return true
                }
              }}
              perform={() => {
                onSubmit()
              }}
          /> 
          </div>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerAttdncPartDismiss
